import React from "react";
import { Text, View, Svg, Rect } from "@react-pdf/renderer";

// Custom.
import { styles } from "./styles";
import VoTheme from "ui/theme/vocollege2";

const LogoPlaceholder: React.FC = (props) => {
  return (
    <View style={styles.root}>
      {/*
 // @ts-ignore */}
      <Svg width="150" viewBox="0 0 120 150" debug>
        <Rect
          fill={VoTheme.palette.grey[800]}
          height={150}
          width={120}
          x="0"
          y="0"
          rx="0"
          ry="0"
        />
        <Text fill={VoTheme.palette.common.white} x={40} y={80}>
          LOGO
        </Text>
      </Svg>
    </View>
  );
};

export default LogoPlaceholder;
